<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.delay'),
                        href: null,
                    },
                    {
                        name: student.full_name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            {{ $t('messages.absences') }}
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.turn') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.delay') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(attendance, index) in attendances.data"
                                :key="attendance.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ attendance.date_display }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ attendance.turn_display }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex gap-x-2 items-center"
                                >
                                    <span>{{ attendance.delay_display }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="attendances" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';

export default {
    components: {
        PanelPage,
        InertiaPagination,
    },
    layout: Layout,
    name: 'Index',
    props: ['options', 'attendances', 'student', 'meta'],
    data() {
        return {};
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
